import { FaqAccordionItems } from '@app/widgets';

export const APP_STORE_PUBLISHING_FAQS: FaqAccordionItems[] = [
  {
    question: 'Which app stores are supported?',
    answer: [
      'We support publishing to Apple App Store (including TestFlight) and Google Play Store.',
      'For iOS, builds are automatically uploaded to TestFlight for testing.',
      'For Android, you can publish to Internal, Alpha, Beta, and Production tracks.',
    ].join(' '),
  },
  {
    question: 'How do I set up my store credentials?',
    answer: [
      'For Apple App Store, you need an App Store Connect API key with appropriate permissions.',
      'For Google Play Store, you need a service account JSON key with publishing permissions.',
      'All credentials are stored securely and encrypted.',
    ].join(' '),
  },
  {
    question: 'Can I publish to multiple tracks?',
    answer: [
      'Yes! For Google Play, you can configure multiple destinations for different tracks (Internal, Alpha, Beta, Production).',
      'For iOS, builds are automatically uploaded to TestFlight and can be promoted to App Store.',
    ].join(' '),
  },
  {
    question: 'Can I automate publishing from my CI/CD pipeline?',
    answer: [
      'Absolutely! You can trigger publishing using our <a href="https://capawesome.io/cloud/cli/" target="_blank">CLI tool</a> or <a href="https://capawesome.io/cloud/api/" target="_blank">API</a>.',
      'When combined with Native Builds, you can set up fully automated deployments from code push to store publication.',
    ].join(' '),
  },
  {
    question: 'What happens if a submission fails?',
    answer: [
      'You will receive detailed error messages explaining why the submission failed.',
      'Common issues include invalid credentials, missing metadata, or store policy violations.',
      'Our support team is available to help you resolve any publishing issues.',
    ].join(' '),
  },
];
